let basePath, accessToken, api, uploadUrl, headImgUploadUrl, bannerUploadUrl, websocketPath, socketIOUrl, h5_url,
    web_url;

basePath = process.env.VUE_APP_BASE_PATH;
uploadUrl = process.env.VUE_APP_UPLOAD_URL;
headImgUploadUrl = process.env.VUE_APP_HEADIMG_UPLOAD_URL;
bannerUploadUrl = process.env.VUE_APP_BANNER_UPLOAD_URL;
websocketPath = process.env.VUE_APP_WEBSOCKET_PATH;
socketIOUrl = process.env.VUE_APP_SOCKETIO_URL;
h5_url = process.env.VUE_APP_H5_URL;
web_url = process.env.VUE_APP_WEB_URL;

let DATE_CONSTANT = {
  MORNING: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
  AFTERNOON: [12, 13, 14, 15, 16, 17, 18, 19],
  EVENING: [20, 21, 22, 23]
};

api = {
  "login": basePath + 'oauth/token',
  "captcha": basePath + 'code/captcha',
  "logout": basePath + 'sys/logout',
  "checkMobile": basePath + 'sys/checkMobile',
  checkEmail: basePath + 'sys/checkEmail',
  "register": basePath + 'ysh/user/register/{type}',
  "isUsed": basePath + 'ysh/isUsed',
  "current": basePath + 'sys/authorize/current',
  permissions_me: basePath + 'auth/permissions/authorize/me/all',
  checkMobile_reset: basePath + 'sys/checkMobile-reset',
  resetPwd_mobile: basePath + "sys/reset/password/mobile",
  updatePhone_mobile: basePath + "sys/update/mobile/authorize",

  checkEmail_reset: basePath + 'sys/checkEmail-reset',
  resetPwd_email: basePath + "sys/reset/password/email",
  updateEmail_email: basePath + "sys/update/email/authorize",
  wechat: {
    isBind: basePath + 'sys/authorize/isBind/wechat/openid',
    info: basePath + 'wx/authorize/info',
    qrcode: basePath + 'wx/authorize/qrcode',
    qrcode_status: basePath + 'wx/authorize/qrcode/status',
  },
  sms: {
    register: basePath + "code/register/sms",
    resetPwd: basePath + "code/resetPwd/sms",
    udpatePhone: basePath + "code/updatePhone/sms/authorize",
    updateMobile: basePath + 'code/authorize/update-mobile/sms'
  },
  email: {
    register: basePath + "code/register/email",
    resetPwd: basePath + "code/resetPwd/email",
    udpateEmail: basePath + "code/updateEmail/email/authorize",
    updateEmail: basePath + 'code/authorize/update-email/email'
  },
  auth: {
    updateMobile: basePath + 'sys/authorize/update/login-mobile',
    updateEmail: basePath + 'sys/authorize/update/login-email',
  },
  "doctor": {
    baseAll: basePath + "auth/auth-doctor/admin/list/base-all",
    teamBaseAll: basePath + "auth/auth-doctor/admin/list/team/base-all",
    teamList: basePath + 'auth/auth-doctor/list/team/baseInfo',
    condition: basePath + 'auth/auth-doctor/list/new/condition', // 注册医生+咨询师
    "regist": basePath + 'ysh/doctor/register',
    "index": basePath + 'auth/auth-doctor/index/{account}',
    "exist": basePath + 'auth/auth-doctor/exist/{account}', // 是否存在
    "list": basePath + 'auth/auth-doctor/admin/list/{pg}/{ps}',
    "patients": basePath + 'auth/doctor-patients/authorize/list/{pg}/{ps}',
    "appointSetting": basePath + 'auth/auth-doctor/authorize/appointSetting',
    "saveAppointSet": basePath + 'authorize/medical/doctor-appoint-set/save',
    "delAppointSet": basePath + 'authorize/medical/doctor-appoint-set/del',
    "patient": {
      "appointOp": basePath + 'auth/doctor-patients/authorize/appointOp',// 设置患者是否可以预约
      "detail": basePath + 'auth/doctor-patients/authorize/detail/{id}',//医生查看自己的某个患者信息
    },
    "detail": basePath + "auth/auth-doctor/authorize/doctorDetail",
    "indication": basePath + "indications/indication/listByDoctorId/{id}",//根据医生id获取适应症
    "indicationId": basePath + "indications/indication/listIdByDoctorId/{id}",//根据医生id获取适应症id
    "allIndicationId": basePath + "indications/indication/listAllId",//获取所有有效的适应症id
    "updateBase": basePath + "auth/doctor-supplement/authorize/updateBase",//更新医生基本信息
    "updateJob": basePath + "auth/auth-doctor/authorize/updateDoctorJob",//更新医生专业资质
    "updateBank": basePath + "auth/auth-doctor/authorize/updateBank",//更新医生账户信息
    "updateHonor": basePath + "auth/doctor-supplement/authorize/updateHonor",//更新医生荣誉成就
    "updateIndication": basePath + "indication/indication-doctor/authorize/updateDoctorIndication",//更新医生服务类型
    "updateBrief": basePath + "auth/doctor-supplement/authorize/updateBrief",//更新医生简介
    listConcern: basePath + 'auth/auth-doctor/authorize/page/concern/{size}/{page}',
    "consult": {
      "detail": basePath + 'auth/auth-doctor/consult/{account}',
      "authorizeDetail": basePath + 'auth/auth-doctor/authorize/consult/{account}'
    },
    "medicalRecord": {
      "pageByDoctor": basePath + "medical/medical-record/authorize/pageByDoctor/{currentPage}/{pageSize}",//根据医生查找
      "recordDoctorByMedical": basePath + "medical/medical-record/authorize/ByMedicalNoDoctor/{medicalNo}",//
    },//
    "reservation": {
      "detailByNoDoctor": basePath + "medical/medical-appoint/authorize/appointDetailByNoDoctor/{appointNo}",//医生根据预约号查详情
      "createRecord": basePath + "medical/medical-record/authorize/createRecord/{id}",//添加
      "appointCancel": basePath + "event/operate-log/authorize/appointCancel",//取消预约
      "chatComplete": basePath + "medical/medical-record/authorize/chatComplete/{id}",//通话完成，修改状态
      // 2021-03-12
      "pageByCondition": basePath + "medical/medical-appoint/authorize/page/condition/{page}/{size}",//多条件分页查询
    },//预约管理
    "admin": {
      "resetPassword": basePath + "auth/auth-doctor/admin/resetPassword",//重置密码
      "remark": basePath + "auth/auth-doctor/admin/remark",//更新备注
      "detail": basePath + "auth/auth-doctor/admin/detail/{id}",//管理员查看医生详情
    },//管理员
    "timezoneSelf": basePath + 'auth/doctor-supplement/authorize/timezone', //获取当前登录用户的工作时区
    "timezoneByAccount": basePath + 'auth/doctor-supplement/timezone/{account}', //根据医生账号获取工作时区
  },
  "user": {
    "detail": basePath + 'auth/auth-user/authorize/details/{uid}',// 个人详情
    "edit": basePath + 'auth/auth-user/authorize/edit',//
    // "invoice": basePath + 'auth/auth-user/authorize/invoice',// 我的发票
    "saveInvoice": basePath + "financial/invoice-setting/authorize/save/{userId}",
    "appoints": basePath + 'medical/medical-appoint/authorize/appoints/{pg}/{ps}',// 预约分页
    "appointCalc": basePath + 'medical/medical-appoint/authorize/calc',// 个人预约统计
    "appointDetail": basePath + 'medical/medical-appoint/authorize/appoint/{id}',// 预约信息
    "appointOrder": basePath + 'medical/medical-appoint/authorize/order/{id}',// 预约信息(支付页面用)
    "addUserConcern": basePath + 'auth/user-concern/authorize/add/{doctorId}',//用户关注医生
    "deleteUserConcern": basePath + 'auth/user-concern/authorize/delete/{doctorId}',//用户取消关注医生
    "getUserConcern": basePath + 'auth/user-concern/authorize/get/{account}',//用户是否关注了医生
    "admin": {
      "page": basePath + "auth/auth-user/admin/page/{current}/{size}",//查-page
      "status": basePath + "auth/auth-user/admin/status/{status}",//改-状态
      "password": basePath + "auth/auth-user/admin/resetPassword",//改-重置密码
      "remark": basePath + "auth/auth-user/admin/remark/{userId}",//改-备注
      "detail": basePath + "auth/auth-user/admin/detail/{id}",//查-detail
    },//管理员
  },
  "doctorBanners": basePath + 'article/article-banner/authorize/list/doctor',
  "addBanner": basePath + 'article/article-banner/authorize/add',
  "updateBanner": basePath + 'article/article-banner/authorize/update/',
  "delBanner": basePath + 'article/article-banner/authorize/del/',
  banner: {
    index: {
      list: basePath + "article/article-banner/list/index",
      add: basePath + "article/article-banner/admin/index/add",
      update: basePath + "article/article-banner/admin/index/update/{id}",
      del: basePath + "article/article-banner/admin/index/del/{id}"
    },
  },//轮播图
  appoint: {
    appointArr: basePath + 'medical/medical-appoint/authorize/appoint-arr',
    save: basePath + 'medical/medical-appoint/authorize/appoint',
    toUpdate: basePath + 'medical/medical-appoint/authorize/can-update/{id}',
    toCancel: basePath + 'medical/medical-appoint/authorize/can-cancel/{id}',
    read: basePath + 'medical/medical-appoint/authorize/read/{id}',
    message: basePath + 'medical/medical-appoint/authorize/message',
    cancel: basePath + 'medical/medical-appoint/authorize/cancel/{id}',
    pay: basePath + "medical/pay/authorize/pay/{id}/wx",
    orderStatus: basePath + "medical/pay/authorize/isPay/{no}",
    cancelNoPay: basePath + 'medical/medical-appoint/authorize/noPay/cancel/{id}',
    details_doctor: basePath + 'medical/medical-appoint/authorize/doctor/{no}',
    admin: {
      page: basePath + "medical/medical-appoint/admin/page/{current}/{size}",//查-page
      update: basePath + "medical/medical-appoint/admin/update",//修改日期
      cancel: basePath + "medical/medical-appoint/admin/cancel",//取消
      remind: basePath + "medical/medical-appoint/admin/remind",//微信提醒
      detail: basePath + "medical/medical-appoint/admin/detail/{id}",//查-detail
    },//管理员

    // 通话相关
    consult: {
      socketUrl: websocketPath + "ws/appoint/{room}/{userId}",
      roomToken: basePath + "medical/appoint/consult/authorize/room/socket/{id}", // websocket open token
      roomSign: basePath + "medical/appoint/consult/authorize/room/sign/web/{id}",// trtc room sign
    }
  },

  approveProcess: {
    appointUpdate: basePath + 'approve/authorize/appoint/update',
    getByAppointId: basePath + 'approve/authorize/appoint/{id}',
  },

  dict: {
    professional_department: basePath + "dict/dict-catalog-item/list/professional_department",
    appoint: {
      update: basePath + "dict/dict-catalog-item/list/appoint_update_notice",
      cancel: basePath + "dict/dict-catalog-item/list/appoint_cancel_notice",
    },
    article: {
      research: basePath + "dict/dict-catalog-item/list/research_type",
      science: basePath + "dict/dict-catalog-item/list/science_type",
      system: {
        itemList: basePath + "dict/dict-catalog-item/list/article_system",
      }
    },
    exam: {
      type: basePath + "dict/dict-catalog-item/list/exam_type",
    },
    lecture: {
      speciality: basePath + "dict/dict-catalog-item/list/lecture_speciality",
      level: basePath + "dict/dict-catalog-item/list/lecture_level",
    },
    userQA: basePath + "dict/dict-catalog-item/list/user_question_answer",
    item: {
      updateStatus: basePath + "dict/dict-catalog-item/admin/status/{id}/{status}",
      add: basePath + "dict/dict-catalog-item/admin/add/{catalogId}",
      edit: basePath + "dict/dict-catalog-item/admin/update",
      getById: basePath + "dict/dict-catalog-item/getById/{id}",
      getByItemCode: basePath + "dict/dict-catalog-item/get/itemCode/{itemCode}"
    },
    sub: {
      getById: basePath + "dict/dict-catalog-subitem/getById/{id}"
    },
    edit: {//管理
      list: basePath + "dict/dict-catalog/admin/list",//查-lise
      detail: basePath + "dict/dict-catalog/admin/detail/{id}",//查-detail
      getByCode: basePath + "dict/dict-catalog/admin/code/{code}",
      save: basePath + "dict/dict-catalog/admin/save",//增
      update: basePath + "dict/dict-catalog/admin/update",//更新
      // delete: basePath + "dict/dict-catalog/admin/delete/{id}",//删除
      item: {//二级表
        list: basePath + "dict/dict-catalog-item/admin/list/{catalogId}",//查
        listByCode: basePath + "dict/dict-catalog-item/admin/code/list/{code}",//根据code查询
        detail: basePath + "dict/dict-catalog-item/admin/detail/{id}",//查-detail
        save: basePath + "dict/dict-catalog-item/admin/save",//增
        update: basePath + "dict/dict-catalog-item/admin/update",//更新
        delete: basePath + "dict/dict-catalog-item/admin/delete/{id}",//删除
      },
      sub: {//三级表
        list: basePath + "dict/dict-catalog-subitem/admin/list/{itemId}",//查
        detail: basePath + "dict/dict-catalog-subitem/admin/detail/{id}",//查-detail
        save: basePath + "dict/dict-catalog-subitem/admin/save",//增
        update: basePath + "dict/dict-catalog-subitem/admin/update",//更新
        delete: basePath + "dict/dict-catalog-subitem/admin/delete/{id}",//删除
        updateStatus: basePath + "dict/dict-catalog-subitem/admin/status/{id}/{status}",
      },
    },
    subitem: {
      listByItemId: basePath + "dict/dict-catalog-subitem/list/itemId/{itemId}",
    }
  },
  recommend: {
    news: basePath + "recommend/recommends/type/news",
    doctor: basePath + "recommend/recommends/type/doctor",
    research: basePath + "recommend/recommends/type/research",
    drug: basePath + "recommend/recommends/type/drug",
    consultation: basePath + "recommend/recommends/type/consultation",
    lecture: basePath + "recommend/recommends/type/lecture",
    exam: basePath + "recommend/recommends/type/exam",
    drug_fresh: basePath + "drug/drug-fresh/show/list",

  },
  exam: {
    baseAll: basePath + "exams/exam/admin/list/base-all",
    top: basePath + "exams/exam/list/top",
    list: basePath + "exams/exam/list/type/page",
    details: basePath + "exams/exam/details/{id}",
    examResult: basePath + "exams/exam/authorize/details/{id}",
    hasNo: basePath + "exam/exam-result/authorize/my/{id}",
    analysis: basePath + "exam/exam-analysis/authorize/list/{id}",
    message: {
      list: basePath + "exams/exam-message/list/page/{id}"
    },
    subject: {
      question: basePath + "exam/exam-subject/authorize/subject/{no}",
      answer: basePath + "exam/exam-result-option/authorize/result-answer/{id}",
      doAnswer: basePath + "exam/exam-result-option/authorize/answer/{no}-{id}",
    },
    submit: basePath + "exam/exam-result/authorize/submit/{no}",
    result: {
      count: basePath + "exam/exam-result/authorize/count",
      list: basePath + "exam/exam-result/authorize/my/list",
      details: basePath + "exam/exam-result/authorize/details/{no}",
      evaluate: basePath + "exam/exam-result/authorize/evaluate/{no}",

      detailByNo: basePath + "exam/exam-result/authorize/moreDetails/{resultNo}",//根据编号
      analysis: basePath + "exam/exam-result/authorize/analysis/details/{no}",

    },
    doctor: {
      newPage: basePath + "exam/exam-result/authorize/doctor/list/new/{current}/{size}",//新的测试分析
      addResult: basePath + "exam/exam-result/authorize/doctor/result",//医生填结果
      oldPage: basePath + "exam/exam-result/authorize/doctor/list/old/{current}/{size}",//医生已经分析过的结果
    },//医生
  },
  coupon: {
    statistics: basePath + 'coupon/coupon-user/authorize/statistics',
    available: basePath + 'coupon/coupon-user/authorize/me/available',
    unavailable: basePath + 'coupon/coupon-user/authorize/me/unavailable'
  },
  article: {
    information: {
      baseAll: basePath + "article/information/admin/list/base-all",
      page: basePath + "article/information/list/page",
      pageById: basePath + "article/information/authorize/list/{currentPage}/{pageSize}",
      details: basePath + "article/information/details/{id}",
      details_name: basePath + "article/information/details-name/{id}", //包含doctorName

      details_auth: basePath + 'article/information/authorize/details/{id}',
      details_auth_intact: basePath + 'article/information/authorize/details-intact/{id}', //包含doctorName

      isLiked: basePath + "article/information/authorize/{id}/liked",
      likes: basePath + "article/information/authorize/{id}/likes",

      edit: basePath + "article/information/authorize/edit/{id}",
      add: basePath + "article/information/authorize/add",
      update: basePath + "article/information/authorize/update",
      delete: basePath + "article/information/authorize/del/{id}",
      cancel: basePath + "article/information/authorize/cancel/{id}",//取消发布

      weekHot: basePath + "article/information/week/hot"
    },
    science: {
      page: basePath + "article/sciences/list/type/{type}",
      details: basePath + "article/sciences/details/{id}",
      details_auth: basePath + "article/sciences/authorize/details/{id}",
      likes: basePath + "article/sciences/authorize/{id}/likes",
      isLiked: basePath + "article/sciences/authorize/{id}/liked",
      pageById: basePath + "article/sciences/authorize/list/{currentPage}/{pageSize}",
      edit: basePath + "article/sciences/authorize/edit/{id}",
      add: basePath + "article/sciences/authorize/add",
      update: basePath + "article/sciences/authorize/update",
      delete: basePath + "article/sciences/authorize/del/{id}",
      cancel: basePath + "article/sciences/authorize/cancel/{id}",//取消发布
    },
    research: {
      baseAll: basePath + 'article/researches/admin/list/baseAll',
      page: basePath + "article/researches/list/type/{type}",
      details_anyone: basePath + "article/researches/details/{id}",
      details_auth: basePath + "article/researches/authorize/details/{id}",

      details_anyone_intact: basePath + "article/researches/details-intact/{id}",
      details_auth_intact: basePath + "article/researches/authorize/details-intact/{id}",

      likes: basePath + "article/researches/authorize/{id}/likes",
      isLiked: basePath + "article/researches/authorize/{id}/liked",
      pageById: basePath + "article/researches/authorize/list/{currentPage}/{pageSize}",
      edit: basePath + "article/researches/authorize/edit/{id}",
      add: basePath + "article/researches/authorize/add",
      update: basePath + "article/researches/authorize/update",
      delete: basePath + "article/researches/authorize/del/{id}",
      cancel: basePath + "article/researches/authorize/cancel/{id}",//取消发布

      weekHot: basePath + 'article/researches/week/hot'
    },
    concern: {
      add: basePath + "article/article-concern/authorize/add/{type}",
      delete: basePath + "article/article-concern/authorize/del/{type}",
      get: basePath + "article/article-concern/authorize/get/{type}",
    },//订阅相关
    system: {
      page: basePath + "article/system/page/{subitemId}/{currentPage}/{size}",
      list: basePath + "article/system/list/{subitemId}/{size}",
    }
  },
  indication: {
    types: {
      all: basePath + "indications/indication/list-all",
      simple_all: basePath + "indications/indication/list-all/simple",
      recommend: {
        doctors: basePath + "indication/indication-recommend/{id}/doctor",
        exams: basePath + "indication/indication-recommend/{id}/exam"
      }
    },
    edit: {//管理员
      list: basePath + "indications/indication/admin/list",//
      status: basePath + "indications/indication/admin/status/{status}/{indicationId}",//
      delete: basePath + "indications/indication/admin/delete/{indicationId}",//
      detail: basePath + "indications/indication/admin/one/{indicationId}",//
      saveUpdate: basePath + "indications/indication/admin/saveUpdate/{indicationId}",//
      order: basePath + "indications/indication/admin/order",//
      recommend: {//推荐
        list: basePath + "indication/indication-recommend/admin/list/{type}/{indicationId}",//推荐-查-已经推荐列表
        update: basePath + "indication/indication-recommend/admin/update/{type}/{indicationId}",//推荐-改-更新
        order: basePath + "indication/indication-recommend/admin/order/{type}",//推荐-改-排序
      },
    }
  },
  drug: {
    baseAll: basePath + "drugs/drug/admin/list/base-all",
    page: basePath + "drugs/drug/authorize/list/page/condition",
    details: basePath + "drugs/drug/details/{id}",
    details_auth: basePath + "drugs/drug/authorize/details/{id}",
    tops: basePath + "drugs/drug/list/top",
    category: {
      all: basePath + "drug/categories/all",
      simple_all: basePath + "drug/categories/all/simple"
    },
    edit: {//管理员
      page: basePath + "drugs/drug/admin/list/page/condition",//药物-查-分页
      status: basePath + "drugs/drug/admin/status/{status}/{drugId}",//药物-改-状态
      delete: basePath + "drugs/drug/authorize/delete/{drugId}",//药物-删
      detail: basePath + "drugs/drug/admin/edit/detail/{id}",//药物-查-详情
      saveUpdate: basePath + "drugs/drug/authorize/saveUpdate/{type}",//药物-0增1改
      category: {
        list: basePath + "drug/categories/admin/all",//药物类别-查-列表
        status: basePath + "drug/categories/admin/status/{status}/{categoryId}",//药物类别-改-状态
        deleteCategory: basePath + "drug/categories/admin/delete/{categoryId}",//药物类别-删
        order: basePath + "drug/categories/admin/order",//药物类别-改-排序
        detail: basePath + "drug/categories/admin/detail/{categoryId}",//药物类别-查-详情
        saveUpdate: basePath + "drug/categories/admin/saveUpdate/{categoryId}",//药物类别-增/改
      },
    },
    fresh: {
      page: basePath + 'drug/drug-fresh/admin/list/page',
      changeStatus: basePath + 'drug/drug-fresh/admin/status/{id}/{status}',
      del: basePath + 'drug/drug-fresh/admin/del/{id}',
      edit: basePath + 'drug/drug-fresh/admin/update/{id}',
      add: basePath + 'drug/drug-fresh/admin/add'
    },
    concern: {
      add: basePath + "drug/drug-concern/authorize/add/{drugId}",//关注
      delete: basePath + "drug/drug-concern/authorize/del/{drugId}",//取消关注
      get: basePath + "drug/drug-concern/authorize/get/{drugId}"//是否关注
    }
  },
  expert: {
    isJoin: basePath + "expert/register/authorize/isJoin/{id}",
    join: basePath + "expert/register/authorize/join/{type}",
    consultation: {
      baseAll: basePath + "experts/consultation/admin/list/base-all",
      list_all: basePath + "experts/consultation/list/page",
      list_me: basePath + "experts/consultation/authorize/list/page/me",
      details: basePath + "experts/consultation/details/{id}",
      isJoin: basePath + "experts/consultation/authorize/isJoin/{id}",
      count: basePath + "experts/consultation/authorize/count",
    },
    lecture: {
      baseAll: basePath + "experts/lecture/admin/list/base-all",
      page_auth: basePath + "experts/lecture/authorize/list/page",
      page_anyone: basePath + "experts/lecture/list/page",
      list_me: basePath + "experts/lecture/authorize/list/page/me",
      count: basePath + "experts/lecture/authorize/count",

      details_auth: basePath + "experts/lecture/authorize/details/{id}",
      details_anyone: basePath + "experts/lecture/details/{id}",
      base_info: basePath + "experts/lecture/authorize/base-info/{id}",
      videoViews: basePath + "experts/lecture/authorize/videoViews/{id}",
    }
  },
  area: {//城市
    list: basePath + "area/area-city/list",
    item: basePath + "area/area-city-item/list/cityId/{id}",
  },
  famousDoctor: {
    //newDoctors: basePath + "auth/doctor-supplement/newDoctors",
    //famousDoctorPage: basePath + "auth/doctor-supplement/famousDoctors/{currentPage}/{pageSize}",
    conditionPage: basePath + 'auth/auth-doctor/page/famous',
    concernPage: basePath + 'auth/auth-doctor/authorize/condition/concern',
    city: basePath + "area/area-city/listCityName",
    city_group: basePath + "auth/auth-doctor/city",
    indication: basePath + "indications/indication/listIndicationCNName",
    appTime: basePath + "dict/dict-catalog-item/listTime",
    department_tags: basePath + 'auth/doctor-tags/department',
  },
  chat: websocketPath + 'ws/chat/',
  event: {//事件
    edit: {//管理员
      page: basePath + "event/operate-log/admin/page/{current}/{size}",//分页
      remark: basePath + "event/operate-log/admin/remark",//备注
      historyArticle: basePath + "event/event-article/admin/detail/{id}",//历史文章
    },
  },
  message: {
    template: {
      add: basePath + "event/template-message/admin/add",
      delete: basePath + "event/template-message/admin/delete/{id}",
      update: basePath + "event/template-message/admin/update",
      tag: basePath + "event/template-message/admin/tag",
      page: basePath + "event/template-message/admin/page/{current}/{size}",
      detail: basePath + "event/template-message/admin/detail/{id}",
      inputSuggestion: basePath + "event/template-message/admin/title/suggestion/{number}",
      weChat: {
        list: basePath + "event/wx-template/admin/list",
        detail: basePath + "event/wx-template/admin/detail",
        update: basePath + "event/wx-template/admin/update"
      }
    },//模板消息
    system: {
      page: basePath + "event/system-message/authorize/page/{current}/{size}",
      countNotRead: basePath + "event/system-message/authorize/countNotRead",
      read: basePath + "event/system-message/authorize/read/{id}",
    },//系统通知
  },//消息
  upload: {
    chatImg: basePath + 'xcx/chat/img/upload',
    private_url: {
      cv: basePath + 'ysh/private/upload/cv',
    },
    token: {
      appoint: basePath + 'medical/medical-appoint-file/authorize/download/{id}',
    },
    download: {
      token: basePath + 'ysh/download-file/token/{token}',
    }
  },
  communication: {
    chat: {
      one: basePath + 'communication/comm-chat/authorize/one/{id}', // 获取一个chat信息: 限自己相关
      list_me: basePath + 'communication/comm-chat/authorize/page/chat/{pg}/{ps}',
      create: basePath + 'communication/comm-chat/authorize/create/chat/{uid}',
      message: basePath + 'communication/comm-chat-message/authorize/page/{id}', // 默认 page:1 size: 10
      sendText: basePath + 'communication/comm-chat-message/authorize/send/text/{id}',
      sendImg: basePath + 'communication/comm-chat-message/authorize/send/image/{id}',
      unreadCount: basePath + 'communication/comm-chat-message/authorize/unread/total',
      unreadList: basePath + 'communication/comm-chat-message/authorize/unread/list',
      cleanChatUnread: basePath + 'communication/comm-chat-message/authorize/read/chat/{id}',
      member: {
        list: basePath + 'communication/comm-chat-member/authorize/formal/list/{id}',
        name: basePath + 'communication/comm-chat-member/authorize/formal/name/{id}',
      },
      disturb: basePath + 'communication/comm-chat/authorize/set-disturb/{id}/{status}',
      setTop: basePath + 'communication/comm-chat/authorize/set-top/{id}/{status}',
      dismiss: basePath + 'communication/comm-chat/authorize/dismiss-chat/{id}',
      friendApply: basePath + 'communication/comm-contacts-apply/authorize/page',
      isAccept: basePath + 'communication/comm-contacts-apply/authorize/approve/{id}/{status}',
      unprocessed: basePath + 'communication/comm-contacts-apply/authorize/count/unprocessed',
      applySubmit: basePath + 'communication/comm-contacts-apply/authorize/apply/submit/{id}',
      contacts: basePath + 'communication/comm-contacts/authorize/page/contacts',
      isContacts: basePath + 'communication/comm-contacts/authorize/contacts/{id}',
      groupSearch: basePath + 'communication/comm-chat/authorize/group-chat/search/{keyword}',
    }
  },
  feedback: {//用户反馈
    add: basePath + "feedback/authorize/add",//添加用户反馈
    list: basePath + "feedback/list",//获取用户反馈
  },
};

let manager_api = {
  article: {
    event_log: basePath + 'event/operate-log/admin/list/event_article/{id}',
    news: {
      list: basePath + "article/information/admin/page",
      details: basePath + "article/information/admin/details/{id}",
      approve: basePath + "article/information/admin/approve/{record}",
      changeStatus: basePath + "article/information/admin/changeStatus//{record}",
    },
    science: {
      list: basePath + "article/sciences/admin/page",
      details: basePath + "article/sciences/admin/details/{id}",
      approve: basePath + "article/sciences/admin/approve/{record}",
      changeStatus: basePath + "article/sciences/admin/changeStatus/{record}",
    },
    research: {
      list: basePath + "article/researches/admin/page",
      details: basePath + "article/researches/admin/details/{id}",
      approve: basePath + "article/researches/admin/approve/{record}",
      changeStatus: basePath + "article/researches/admin/changeStatus/{record}",
    },
    system: {
      page: basePath + "article/system/admin/page/{currentPage}/{size}",
      update: basePath + "article/system/admin/update",
      add: basePath + "article/system/admin/add",
      delete: basePath + "article/system/admin/delete/{id}",
      updateStatus: basePath + "article/system/admin/status/{id}/{status}",
      getById: basePath + "article/system/admin/get/{id}"
    },
  },
  recommend: {
    settings: basePath + "admin/recommend/settings/admin/all",
    update: basePath + "admin/recommend/settings/admin/update/setting"

  },
  "approve": {
    "doctor": basePath + "auth/auth-doctor/admin/approve"
  },
  "doctor": {
    "ban": basePath + "auth/auth-doctor/admin/ban",
    "unBan": basePath + "auth/auth-doctor/admin/unBan",
  },
  chat: {
    token: basePath + 'chat/admin/token/{uid}',
    recover: basePath + 'chat/admin/recover/{sessionId}'
  },
  expert: {
    consultation: {
      page: basePath + "experts/consultation/admin/list/page",
      changeStatus: basePath + "experts/consultation/admin/update/status/{id}",
      details: basePath + "experts/consultation/admin/details/{id}",
      del: basePath + "experts/consultation/admin/del/{id}",
      add: basePath + "experts/consultation/admin/add",
      update: basePath + "experts/consultation/admin/update/{id}",
    },
    lecture: {
      page: basePath + "experts/lecture/admin/page/list",
      changeStatus: basePath + "experts/lecture/admin/update/status/{id}",
      details: basePath + "experts/lecture/admin/details/{id}",
      del: basePath + "experts/lecture/admin/del/{id}",
      add: basePath + "experts/lecture/admin/add",
      update: basePath + "experts/lecture/admin/update/{id}",
    },
    register: {
      page: basePath + "expert/register/admin/list/page/{id}",
    }
  },
  exam: {
    page: basePath + "exams/exam/admin/list/page",
    del: basePath + "exams/exam/admin/del/{id}",
    changeStatus: basePath + "exams/exam/admin/update/status/{id}",
    details: basePath + "exams/exam/admin/details/{id}",
    subjects: basePath + "exam/exam-subject/admin/list/{id}",
    add: basePath + "exams/exam/admin/add",
    update: basePath + "exams/exam/admin/update/{id}",
    message: {
      page: basePath + "exams/exam-message/admin/list/page/{id}",
      changeStatus: basePath + "exams/exam-message/admin/update/status/{id}"
    },
    historyList: basePath + "exam/exam-result/admin/old/list/{current}/{size}",//管理员查看历史测试列表
    historyDetail: basePath + "exam/exam-result/admin/detail/{resultNo}",
  },
  auth: {
    user_role: basePath + "auth/auth-user/admin/page/role",
    doctor_role: basePath + "auth/auth-doctor/admin/page/role",
    admin_role: basePath + "sys/admin/page/role",
    admin_add: basePath + "sys/admin/add",
    admin_changeStatus: basePath + "sys/admin/update/status/{id}",
    admin_update: basePath + "sys/admin/update/{id}",
    admin_reset_pwd: basePath + "sys/admin/update/password/{id}",
    role: {
      all: basePath + 'auth/roles/admin/page/all',
      modify: basePath + 'auth/user-role/admin/update/{id}', // 修改用户角色
      page: basePath + 'auth/roles/admin/page',
      del: basePath + 'auth/roles/admin/del/{id}',
      update_permission: basePath + 'auth/role-permission/admin/update/{id}', //修改角色权限
      add: basePath + "auth/roles/admin/add",
      update: basePath + "auth/roles/admin/update/{id}",
    },
    all_permissions: basePath + 'auth/permissions/admin/page/all',
    permissions_me: basePath + 'auth/permissions/admin/me/all' //获取自己的权限
  },
  feedback: {//反馈管理
    page: basePath + 'feedback/admin/page',
    delete: basePath + 'feedback/admin/delete/{id}',
    ban: basePath + 'feedback/admin/ban/{id}',
    unban: basePath + 'feedback/admin/unban/{id}',
    update: basePath + 'feedback/admin/update',
    updateSelect: basePath + 'feedback/admin/update/select/{id}',
    cancelSelect: basePath + 'feedback/admin/cancel/select/{id}',
    listSelected: basePath + 'feedback/admin/selected/list',
    updateSelectedSort: basePath + 'feedback/admin/sort/update',
  },
  city: {//城市管理
    list: basePath + "area/area-city/admin/list",
    updateStatus: basePath + "area/area-city/admin/status/update/{status}/{id}",
    delete: basePath + "area/area-city/admin/delete/{id}",
    order: basePath + "area/area-city/admin/order",//改-排序
    save: basePath + "area/area-city/admin/save",
    update: basePath + "area/area-city/admin/update/{id}",
    item: {
      list: basePath + "area/area-city-item/admin/list/{cityId}",//查-列表
      updateStatus: basePath + "area/area-city-item/admin/status/update/{status}/{id}",//改-状态
      delete: basePath + "area/area-city-item/admin/delete/{id}",//删
      save: basePath + "area/area-city-item/admin/save/{cityId}",
      update: basePath + "area/area-city-item/admin/update/{id}",
      updateSort: basePath + "area/area-city-item/admin/sort/update/{cityId}",
    }
  },
};


import ajax from 'axios';
import md5 from 'js-md5';

let utils = {
  getQueryString: function (name) {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    let r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
  },

  getCurrent: async function () {
    let currentUser = null;
    let config = {headers: []};
    if (localStorage.access_token) {
      config = {headers: {"Authorization": "bearer " + localStorage.access_token}}
    }
    let user = await ajax.get(basePath + "sys/current", config).then((res) => {
      return res.data;
    });
    if (user.id) {
      currentUser = user;
    }
    return currentUser;
  },

  generateAppointTimeSlot(appointSetting) {
    let arr = appointSetting.split("#");

    let weekday = new Set([...arr[0].split(","), ...arr[1].split(","), ...arr[2].split(","), ...arr[3].split(","), ...arr[4].split(",")].filter(x => x).map(Number));
    let weekend = new Set([...arr[5].split(","), ...arr[6].split(",")].filter(x => x).map(Number));

    let weekday_morning = new Set(DATE_CONSTANT.MORNING.filter(x => weekday.has(x)));
    let weekday_afternoon = new Set(DATE_CONSTANT.AFTERNOON.filter(x => weekday.has(x)));
    let weekday_evening = new Set(DATE_CONSTANT.EVENING.filter(x => weekday.has(x)));
    let weekend_morning = new Set(DATE_CONSTANT.MORNING.filter(x => weekend.has(x)));
    let weekend_afternoon = new Set(DATE_CONSTANT.AFTERNOON.filter(x => weekend.has(x)));
    let weekend_evening = new Set(DATE_CONSTANT.EVENING.filter(x => weekend.has(x)));

    let appointTimeSlotArr = [weekday_morning.size, weekday_afternoon.size, weekday_afternoon.size, weekend_morning.size, weekend_afternoon.size, weekend_evening.size].map((x, i) => {
      return x > 0 ? '#' + (i + 12) + '#' : '';
    }).filter(x => x).join('');

    return appointTimeSlotArr;
  },

  addDate(date, n) {
    date.setDate(date.getDate() + n);
    return date;
  },

  getWeek(date) {
    let week = date.getDay() - 1;
    date = utils.addDate(date, week * -1);
    let firstDate = date.Format('yyyy年MM月');
    let currentFirstDate = new Date(date);
    let weekArr = [];
    let weekArrDate = [];
    for (let i = 0; i < 7; i++) {
      let _date = i == 0 ? date.getDate() : utils.addDate(date, 1);
      if (typeof (_date) == 'number') {
        weekArr.push(_date)
        weekArrDate.push(date.Format('yyyy-MM-dd'));
      } else {
        weekArr.push(new Date(_date).getDate());
        weekArrDate.push(new Date(_date).Format('yyyy-MM-dd'));
      }
    }
    let time = date.Format('yyyy年MM月')
    if (firstDate != time) {
      time = firstDate + ' ~ ' + time;
      //console.log('miaom')
    }
    //console.log(firstDate, time)
    return {
      currentFirstDate: currentFirstDate,
      weekArr: weekArr,
      weekArrDate: weekArrDate,
      time: time
    };
  },
  isWechatClient() {
    let ua = navigator.userAgent.toLowerCase();
    return ua.match(/MicroMessenger/i) == "micromessenger";
  },
  isMobileWeb() {
    return /Mobile|Android|webOS|iPhone|iPad|Phone/i.test(navigator.userAgent);
  },
  secondToDate(second) {
    let h = Math.floor(second / 3600) < 10 ? '0' + Math.floor(second / 3600) : Math.floor(second / 3600);
    let m = Math.floor((second / 60 % 60)) < 10 ? '0' + Math.floor((second / 60 % 60)) : Math.floor((second / 60 % 60));
    let s = Math.floor((second % 60)) < 10 ? '0' + Math.floor((second % 60)) : Math.floor((second % 60));
    return h + ":" + m + ":" + s;
  },
  /** 图片压缩，默认同比例压缩
    *  @param {Object} fileObj
    *  图片对象
    *  回调函数有一个参数，base64的字符串数据
    */
  compress(fileObj, callback) {
    try {
      const image = new Image()
      image.src = URL.createObjectURL(fileObj)
      image.onload = function () {
        const that = this
        // 默认按比例压缩
        let w = that.width
        let h = that.height
        const scale = w / h
        w = fileObj.width || w
        h = fileObj.height || (w / scale)
        let quality = 0.7 // 默认图片质量为0.7
        // 生成canvas
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')
        // 创建属性节点
        const anw = document.createAttribute('width')
        anw.nodeValue = w
        const anh = document.createAttribute('height')
        anh.nodeValue = h
        canvas.setAttributeNode(anw)
        canvas.setAttributeNode(anh)
        ctx.drawImage(that, 0, 0, w, h)
        // 图像质量
        if (fileObj.quality && fileObj.quality <= 1 && fileObj.quality > 0) {
          quality = fileObj.quality
        }
        // quality值越小，所绘制出的图像越模糊
        const data = canvas.toDataURL('image/jpeg', quality)
        // 压缩完成执行回调
        const newFile = utils.convertBase64UrlToBlob(data)
        callback(newFile)
      }
    } catch (e) {
      console.log('压缩失败!')
    }
  },
  convertBase64UrlToBlob(urlData) {
    const bytes = window.atob(urlData.split(',')[1]) // 去掉url的头，并转换为byte
    // 处理异常,将ascii码小于0的转换为大于0
    const ab = new ArrayBuffer(bytes.length)
    const ia = new Uint8Array(ab)
    for (let i = 0; i < bytes.length; i++) {
      ia[i] = bytes.charCodeAt(i)
    }
    return new Blob([ab], {type: 'image/png'})
  },
  // 根据传入毫秒值构建展示时间段
  buildShowDate(appointStartLongtime, appointEndLongtime) {
    let startDate = new Date(appointStartLongtime);
    let endDate = new Date(appointEndLongtime);
    return startDate.getDate() === endDate.getDate()
        ? startDate.Format('yyyy-MM-dd HH:mm - ') + endDate.Format("HH:mm")
        : startDate.Format('yyyy-MM-dd HH:mm - ') + endDate.Format("yyyy-MM-dd HH:mm");
  },
  // 生成当前设备签名
  generateDeviceSign() {
    let canvas = document.createElement('canvas');
    let ctx = canvas.getContext("2d");
    let txt = location.host;
    ctx.textBaseline = "top";
    ctx.font = "14px 'Arial'";
    ctx.textBaseline = "ideographic";
    ctx.fillStyle = "#f60";
    ctx.fillRect(125, 1, 62, 20);
    ctx.fillStyle = "#069";
    ctx.fillText(txt, 2, 15);
    ctx.fillStyle = "rgba(102, 204, 0, 0.7)";
    ctx.fillText(txt, 4, 17);

    let b64 = canvas.toDataURL().replace("data:image/png;base64,", "");
    let bin = atob(b64);

    let s = bin.slice(-32, -16)
    s += '';
    let sign = '', n;
    for (let i = 0, l = s.length; i < l; i++) {
      n = s.charCodeAt(i).toString(16);
      sign += n.length < 2 ? '0' + n : n;
    }
    return sign;
  },
  generateBrowserSign() {
    let deviceSign = this.generateDeviceSign();
    let browserUA = navigator.userAgent.toLowerCase();
    let sysPlatform = navigator.platform;
    let colorDepth = window.screen.colorDepth;
    return deviceSign + md5(browserUA + sysPlatform + colorDepth);
  }


};

let reg = {
  account: /^\w{4,16}$/,
  mobile: /^1[3-9]\d{9}$/,
  pass: /^[a-zA-Z_0-9]{6,18}$/,
  email: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
  code: /^[a-zA-Z]\w{3,30}$/,
};

export default {
  basePath,
  uploadUrl,
  headImgUploadUrl,
  bannerUploadUrl,
  api,
  manager_api,
  utils,
  reg,
  DATE_CONSTANT,
  socketIOUrl,
  h5_url,
  web_url
}
